export default IconBmp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bmp" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18 16v-8h2a2 2 0 1 1 0 4h-2" />
  <path d="M6 14a2 2 0 0 1 -2 2h-2v-8h2a2 2 0 1 1 0 4h-2h2a2 2 0 0 1 2 2z" />
  <path d="M9 16v-8l3 6l3 -6v8" />
</svg>`;